<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="50%" :title="' 频率编辑'" @close="cancel">
    <el-form :model="value" :rules="comRules" ref="editor" :label-width="formLabelWidth" style="padding-right: 5rem">
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input class="default-input" size="small" type="text" placeholder="请输入名称" v-model="value.name" :disabled="value.disabled" @change="genPinYin"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编码" prop="code">
            <el-input class="default-input" size="small" type="text" placeholder="请输入编码" v-model="value.code" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="助记码" prop="shortCode">
            <el-input class="default-input" size="small" type="text" placeholder="请输入助记码" v-model="value.shortCode" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="医联编码" prop="standardCode">
            <el-input class="default-input" size="small" type="text" placeholder="请输入医联编码" v-model="value.standardCode" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="周期单位" prop="cycleUnit">
            <el-input class="default-input" size="small" type="text" placeholder="请输入周期单位" v-model="value.cycleUnit" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="周期数量" prop="cycle">
            <el-input class="default-input" size="small" type="number" placeholder="请输入周期数量" v-model="value.cycle" :min="1" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="频次" prop="frequencyTimes">
            <el-input class="default-input" size="small" type="number" placeholder="请输入频次" v-model="value.frequencyTimes" :min="1" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="执行间隔(天)" prop="intervalDays">
            <el-input class="default-input" size="small" type="number" placeholder="请输入执行间隔(天)" v-model="value.intervalDays" :min="1" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="日时间点" prop="dailyTime">
            <el-input class="default-input" size="small" type="text" placeholder="请输入日时间点" v-model="value.dailyTime" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="门诊用" prop="forOp">
            <el-checkbox size="small" v-model="value.forOp" :disabled="value.disabled"> </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="住院用" prop="forIp">
            <el-checkbox size="small" v-model="value.forIp" :disabled="value.disabled"> </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="药品用" prop="forDrug">
            <el-checkbox size="small" v-model="value.forDrug" :disabled="value.disabled"> </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="草药用" prop="forHerbal">
            <el-checkbox size="small" v-model="value.forHerbal" :disabled="value.disabled"> </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="医技用" prop="forMl">
            <el-checkbox size="small" v-model="value.forMl" :disabled="value.disabled"> </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="排序" prop="seqNo">
            <el-input class="default-input" size="small" type="text" placeholder="请输入排序" v-model="value.seqNo" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="停用" prop="disabled">
            <el-switch v-model="value.disabled" active-color="#ff4949" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="memo">
            <el-input class="default-input" size="small" type="textarea" placeholder="请输入备注" :row="2" v-model="value.memo" :disabled="value.disabled"> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button v-if="!value.id" type="primary" @click="saveAndNext" :disabled="disabledSaveAndNext">保存并继续新建</el-button>
      <el-button type="primary" @click="save" :disabled="isSaving">确 定</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  import { pinyin as py } from "../../../packages/masterdata";
  export default {
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        loading: false,
        formLabelWidth: "120px",
        comRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          frequencyTimes: [{ required: true, message: "请输入频次", trigger: "blur" }],
          intervalDays: [{ required: false, message: "请输入执行间隔(天)", trigger: "blur" }],
          dailyTime: [{ required: true, message: "日时间点", trigger: "blur" }],
        },
        autoNext: false,
        disabledSaveAndNext: false,
        isSaving: false,
      };
    },
    computed: {},
    methods: {
      openEditor() {
        this.disabledSaveAndNext = false;
        this.isSaving = false;
        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }
      },
      save() {
        let _this = this;
        this.$refs.editor
          .validate()
          .then((valid) => {
            if (valid) {
              _this.disabledSaveAndNext = true;
              _this.isSaving = true;
              return api.Frequency.save(_this.value);
            }
          })
          .then((res) => {
            if (_this.autoNext) {
              _this.autoNext = false;
              _this.value.id = null;
              _this.value.code = null;
              _this.value.name = null;
              _this.$utils.log("_this.value ", _this.value);
            } else {
              _this.cancel();
            }
            _this.disabledSaveAndNext = false;
            _this.isSaving = false;
            _this.$message.success("保存成功！");
            _this.$emit("ok", _this.value);
          })
          .catch((err) => {
            if (err) {
              _this.$message.error(err.message || err);
            }
            _this.disabledSaveAndNext = false;
            _this.isSaving = false;
          });
      },
      saveAndNext() {
        this.autoNext = true;
        this.save();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      genPinYin() {
        // if (!this.value.id) {
        this.$set(this.value, "shortCode", py.chnToFirstLetter(this.value.name));
        this.$set(this.value, "code", py.chnToPinYin(this.value.name));
        // }
      },
    },
  };
</script>
<style scoped></style>
